import shortid from 'shortid';
import React, {PropTypes} from 'react';
import TextField from './c_TextField';

export const MaskTypes = {
  phone: 'phone',
  zipCode: 'zipCode',
  date: 'date',
  year: 'year',
  monthYear: 'monthYear'
};

const masks = {
  [MaskTypes.phone] : {
    pattern : '(999) 999-9999',
    filter : /[\(\)\-\s]/g
  },
  [MaskTypes.zipCode] : {
    pattern : '99999'
  },
  [MaskTypes.date] : {
    pattern: '99/99/9999',
    filter : /\//g
  },
  [MaskTypes.year] : {
    pattern: '9999'
  },
  [MaskTypes.monthYear] : {
    pattern: '99/9999',
    filter : /\//g
  }
};

export default class MaskedTextField extends React.Component {
  static propTypes = {
    type : PropTypes.string.isRequired,
    value : PropTypes.string,
    defaultValue : PropTypes.string,
    onChange: PropTypes.func
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.maskValue(props.value || props.defaultValue || '')
    };
  }

  id = shortid.generate();

  componentWillReceiveProps(nextProps) {
    this.setState({value: this.maskValue(nextProps.value || nextProps.defaultValue || '')});
  }

  maskValue(value) {
    const mask = masks[this.props.type];
    return value
  }

  unMaskValue(value) {
    const filter = masks[this.props.type].filter;
    return (filter) ? value.replace(filter, '') : value;
  }

  handleChange = (event) => {
    const value = this.maskValue(event.target.value);
    if (this.props.onChange) {
      this.props.onChange(Object.assign({}, event, {target : {value}}));
    }
    this.setState(Object.assign({}, this.state, {value}));
  }

  render() {
    const {type, value, onChange, ...otherProps} = this.props; // eslint-disable-line no-unused-vars
    return (
      <TextField
        name={`${shortid.generate()}`}
        value={this.state.value}
        onChange={this.handleChange}
        {...otherProps} />
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/MaskedInput.js